export default __webpack_public_path__ + "static/media/case2 (5).53f2e46f.jpg";